<template>
  <validation-observer
    ref="form"
  >
    <b-row>
      <b-col
        md="6"
        sm="12"
      >
        <ok-date-time-picker
          v-model="form.stop_at"
          type="datetime"
          :placeholder="getReplyTrans('stop_at_hint')"
          :min-date="minDatetime"
          is-required
          :label="getReplyTrans('stop_at_hint')"
          :max-date="maxDate"
        />
      </b-col>
      <b-col
        md="6"
        sm="12"
      />
      <template v-if="form.schedule">
        <b-col
          md="3"
          sm="12"
          class-name="mt-2"
        >
          <b-form-radio
            v-model="form.schedule.type"
            name="typeSchedule"
            value="stop"
            class-name="custom-control-primary"
          >
            {{ getReplyTrans('stop_reply') }}
          </b-form-radio>
        </b-col>
        <b-col
          md="3"
          sm="12"
          class-name="mt-2"
        >
          <b-form-radio
            v-model="form.schedule.type"
            name="typeSchedule"
            value="comment"
            class-name="custom-control-primary"
          >
            {{ getReplyTrans('comment_only') }}
          </b-form-radio>
        </b-col>
        <b-col
          v-if="form.message_enabled"
          md="3"
          sm="12"
          class-name="mt-2"
        >
          <b-form-radio
            v-model="form.schedule.type"
            name="typeSchedule"
            value="message_only"
            class-name="custom-control-primary"
          >
            {{ getReplyTrans('message_only') }}
          </b-form-radio>
        </b-col>
        <b-col
          v-if="form.message_enabled"
          md="3"
          sm="12"
          class-name="mt-2"
        >
          <b-form-radio
            v-model="form.schedule.type"
            name="typeSchedule"
            value="message"
            class-name="custom-control-primary"
          >
            {{ getReplyTrans('replace_message') }}
          </b-form-radio>
        </b-col>
        <b-col
          v-if="form.schedule.type==='message'"
          md="12"
          class-name="mt-2"
        >
          <emoji-message-template
            v-model="form.schedule.message"
            name="schedule-message"
            :component-message="form.schedule.message"
          />
        </b-col>
      </template>
    </b-row>
  </validation-observer>
</template>

<script>
import EmojiMessageTemplate from '@/@bya3/components/inputs/EmojiMessageTemplate'
import OkDateTimePicker from '@/@bya3/components/inputs/OkDateTimePicker'
import { mapGetters } from 'vuex'
import { BRow, BCol, BFormRadio } from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'ReplySchedule',
  components: {
    EmojiMessageTemplate,
    OkDateTimePicker,
    BRow,
    BCol,
    BFormRadio,
    ValidationObserver,
  },
  data() {
    return {
      minDatetime: '',
      maxDate: '',
      message: '',

    }
  },
  computed: {
    ...mapGetters({
      form: 'reply/form',
    }),
  },
  created() {
    if (!this.form.schedule) {
      this.$store.commit('reply/SET_FORM', {
        schedule: {
          type: 'stop',
          message: null,
        },
      })
    }
    const today = new Date()
    this.minDatetime = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1).toISOString()
    const max = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate())
    this.maxDate = max.toISOString()
  },
  methods: {
    getReplyTrans(str) {
      return this.$t(`reply.form.${str}`)
    },
  },
}
</script>
